module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Weather/Wind-b1d5654c00e83ab7da5f0fa712fe07dcfeb134f109701f08b124f5a45e18a3d8.svg";